import React, {useState} from 'react'
import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import {SUB_TABS} from './CourseImportExportShared'
import {IMPORT_EXPORT_ENTITIES, IMPORT_EXPORT_ENTITY_ORDER} from './course_import_export_config'
import {StudentExportPanel, StudentImportPanel} from './StudentPanels'
import {AttendanceExportPanel, AttendanceImportPanel} from './AttendancePanels'
import {GradeExportPanel, GradeImportPanel} from './GradePanels'

// "Xuất/Nhập hàng loạt" phân hệ Khóa học - 3 tab: Học viên/Điểm danh/Điểm số (xem
// course_import_export_config.js). KHÁC HẲN 2 nút "Nhập/Xuất dữ liệu học viên"/"...điểm danh"/"...điểm
// số" cũ trong context-menu từng Khóa (Courses.js -> createDataImporter/createDataExporter, luồng
// single-shot cũ không có bước xem lại/lỗi) - màn hình này ĐỘC LẬP, không thay thế, không đụng vào
// luồng cũ. Chỉ admin org có quyền organization_manage_course dùng được (BE tự chặn, xem
// CourseImportExportController::resolveOwnerAndDefinition()).
//
// Mỗi entity có 1 cặp Export/Import Panel RIÊNG (StudentPanels.js/AttendancePanels.js/GradePanels.js)
// - KHÔNG generic hoá UI như Family Book vì bố cục khác hẳn nhau (Học viên: Khóa+Lớp; Điểm danh/Điểm
// số: thêm cả Môn học + không có dedup_method) - phần dùng CHUNG (picker Khóa/Lớp/Môn, ModeToggle,
// InfoBanner...) tách ở CourseImportExportShared.js.
const ENTITY_PANELS = {
    student: {Export: StudentExportPanel, Import: StudentImportPanel},
    attendance: {Export: AttendanceExportPanel, Import: AttendanceImportPanel},
    grade: {Export: GradeExportPanel, Import: GradeImportPanel},
}

const CourseImportExportPage = ({owner_id, owner_type}) => {
    const t = useTranslate()
    const [entityKey, setEntityKey] = useState(IMPORT_EXPORT_ENTITY_ORDER[0])
    const [subTab, setSubTab] = useState(SUB_TABS.EXPORT)
    const entity = IMPORT_EXPORT_ENTITIES[entityKey]
    const panels = ENTITY_PANELS[entityKey]
    const Panel = subTab === SUB_TABS.EXPORT ? panels?.Export : panels?.Import

    return (
        <div className="flex flex-col gap-3">
            <div className="overflow-x-auto">
                <div className="p-1 bg-amber-50 rounded-xl flex items-center gap-2 w-fit">
                    {IMPORT_EXPORT_ENTITY_ORDER.map((key) => (
                        <button
                            key={key} type="button"
                            onClick={() => {setEntityKey(key); setSubTab(SUB_TABS.EXPORT)}}
                            className={classNames('px-3 py-1.5 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer', entityKey === key ? 'background text-amber-700' : 'text-amber-700 opacity-60')}>
                            {t(IMPORT_EXPORT_ENTITIES[key].label)}
                        </button>
                    ))}
                </div>
            </div>

            <div className="flex items-center gap-2">
                <button
                    type="button" onClick={() => setSubTab(SUB_TABS.EXPORT)}
                    className={classNames('px-3 py-1 rounded-full text-xs font-semibold cursor-pointer border', subTab === SUB_TABS.EXPORT ? 'bg-amber-600 border-amber-600 text-white' : 'border-color-200 text-color-400')}>
                    {t('export data')}
                </button>
                <button
                    type="button" onClick={() => setSubTab(SUB_TABS.IMPORT)}
                    className={classNames('px-3 py-1 rounded-full text-xs font-semibold cursor-pointer border', subTab === SUB_TABS.IMPORT ? 'bg-amber-600 border-amber-600 text-white' : 'border-color-200 text-color-400')}>
                    {t('import data')}
                </button>
            </div>

            {Panel && <Panel key={`${entityKey}-${subTab}`} entity={entity} owner_id={owner_id} owner_type={owner_type} t={t}/>}

            {/* Đệm chống bottom nav bar che nội dung cuối trang trên mobile - pattern chuẩn dùng
                chung toàn app (vd DiscoveryPage.js, CoursePage.js...), xem docs/ui/design-principles.md. */}
            <div className="h-32"/>
        </div>
    )
}

export default CourseImportExportPage
